<template>
  <div class="modal" :class="{ opened: opened, closed: closed }">
    <div class="vertical-align-wrapper" @click="close">
      <div
        class="modal__inside"
        :style="{ width, height, 'max-width': maxWidth }"
        :class="modalClass"
        @click.stop
      >
        <div class="modal__inside__top" :class="topClass">
          <div class="modal__inside__top__nadpis">{{ title }}</div>
          <div class="modal__inside__top__close" @click="close"></div>
        </div>
        <div class="modal__inside__obsah">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// k modalu se vzdy importuje i ModalJs.js, ktery obsahuje funkce openModal a closeModal - jsou self-explainatory, funguji ale v dane componente, nemusi se volat componenta Modalu
export default {
  name: "ModalHowTo",
  props: {
    // title se zobrazi na vrchu modalu, muze byt nevyplnene, pak se proste nezobrazuje
    title: {
      type: String,
      default: "",
    },
    // sirka modalu, automaticky 55%, muze byt nastavena v jakekoliv jednotce
    width: {
      type: String,
      default: "55%",
    },
    height: {
      type: String,
      default: null,
    },
    // maximalni sirka, muze omezit maximalni roztazeni
    maxWidth: {
      type: String,
      default: "auto",
    },
    // urcuje classu topu, pro barevne variace
    topClass: {
      type: String,
      default: "",
    },
    // muze se vybrat metoda z parent componenty a pri zavreni se zavola
    closeFunction: {
      type: Function,
      default: () => 1,
    },
    modalClass: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      closed: false,
      opened: false,
    };
  },
  methods: {
    // close modal je slozitejsi pro animaci - this.closed spusti css animation, ktera modal vizualne zavre, az potom dojde k zavreni v booleanu this.opened
    close: function () {
      this.closeFunction();
      this.closed = true;
      var self = this;
      setTimeout(function () {
        self.opened = false;
        self.closed = false;
      }, 300);
    },
    open: function () {
      this.opened = true;
    },
  },
  created() {
    // funkce pro zavirani klavesou esc
    let self = this;
    document.addEventListener("keyup", function (evt) {
      if (evt.keyCode === 27 && self.opened) {
        self.close();
      }
    });
  },
};
</script>

<style>
</style>
